<template>
  <div class="notification-content" v-click-outside="onCancel" @click.stop>
    <button class="notification-close-btn" @click.prevent="onCancel">
      <img
        src="@/assets/img/remove-btn.svg"
        alt="close"
        width="24"
        height="24"
      />
    </button>

    <p class="notification-text">
      <slot>
        {{ text }}
      </slot>
    </p>

    <div class="notification-actions">
      <button
        v-if="showConfirm"
        class="btn btn-middle btn-confirm"
        @click.prevent="onConfirm"
      >
        {{ confirmText }}
      </button>

      <button
        v-if="showCancel"
        class="btn btn-middle btn-cancel"
        @click.prevent="onCancel"
      >
        {{ cancelText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppNotification",

  props: {
    text: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Подтвердить",
    },
    cancelText: {
      type: String,
      default: "Отмена",
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="less">
.notification-content {
  z-index: 999;
  background: #fff;
  max-width: 410px;
  width: 100%;
  height: max-content;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 15px 0px #7d919b;

  .notification-close-btn {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: end;
  }

  .notification-text {
    line-height: 20px;
    text-align: center;
  }

  .notification-actions {
    display: flex;
    padding: 0 19px;
    justify-content: space-between;

    .btn-confirm,
    .btn-cancel {
      height: 44px;
      max-width: 160px;
      width: 100%;
    }

    .btn-cancel {
      background-color: #ff5252;
    }
  }
}
</style>
